import axios from 'axios'
import { Zone } from '../../../interfaces'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../../config/api'

export const createZone = (zone: Zone) => {
  const url = new URL(`${ApiConfig.ZoneApi}`)

  return axios.post(url.toString(), zone)
}

export const updateZone = (zoneId: number, zone: Zone) => {
  const url = new URL(`${ApiConfig.ZoneApi}/${zoneId}`)

  return axios.put(url.toString(), zone)
}

export const getZoneList = (
  page: number,
  pageSize: number,
  filters: Filter[],
  orderBy?: { field: string; direction: string }
) => {
  const url = new URL(`${ApiConfig.ZoneApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  filters.forEach((element) => {
    url.searchParams.set(element.key, element.value.toString())
  })

  if (orderBy && orderBy.field) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const deleteZone = (zoneId: number) => {
  const url = new URL(`${ApiConfig.ZoneApi}/${zoneId}`)

  return axios.delete(url.toString())
}
